import { Formik } from "formik"
import { makeStyles } from "tss-react/mui"
import { MeetingServiceOrder } from "../../../../modules/merchant/accounting/accounting/accountingTypes"
import { getCustomFieldsValues } from "../components/form/formLib"
import { ButtonConfigType } from "../../filters/orderTypeFilter/StandardOrderTypeFilter"
import { OrderFormStatus } from "./helpers"
import { MainOrderFormikRef, MeetingServiceTabValues } from "../components/form/formTypes"
import { useDateTime } from "../../../../modules/localization/useDateTime"
import { useCreateOrderForm } from "./CreateOrderFormContext"
import { CreateOrderType } from "../helpers"
import { OrderForm } from "./OrderForm"
import { defaultPriceList } from "../defaults"

const useStyles = makeStyles()((theme) => ({
    container: {
        minHeight: "100%",
        overflowX: "hidden",
        background: theme.palette.common.white,
    },
}))

type OrderFormContainerProps = Readonly<{
    initialOrderType: CreateOrderType
    newOrderType: CreateOrderType | null
    filteredTabButtonConfig: ButtonConfigType<CreateOrderType>[]
    handleSubmitMeetingService: (values: MeetingServiceTabValues) => void
    formikRef: MainOrderFormikRef
    orderDetails?: MeetingServiceOrder
    orderFormStatusRef: React.MutableRefObject<OrderFormStatus>
}>

export function OrderFormContainer({
    initialOrderType,
    newOrderType,
    filteredTabButtonConfig,
    handleSubmitMeetingService,
    formikRef,
    orderDetails,
    orderFormStatusRef,
}: OrderFormContainerProps) {
    const { classes } = useStyles()
    const dateTimeFactory = useDateTime()
    const { dialogType, orderContext, flowConfig } = useCreateOrderForm()

    const initialValues = getCustomFieldsValues(
        {
            event: null,
            resources: [],
            priceList: defaultPriceList,
            initPriceList: null,
            fullResourcesList: [],
            initAmount: null,
        },
        dateTimeFactory,
        dialogType,
        orderDetails,
        orderContext.mode,
        flowConfig,
    )

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={() => {}}
            validateOnBlur={false}
            innerRef={formikRef}
            enableReinitialize
        >
            <div className={classes.container}>
                <OrderForm
                    initialOrderType={initialOrderType}
                    newOrderType={newOrderType}
                    filteredTabButtonConfig={filteredTabButtonConfig}
                    orderDetails={orderDetails}
                    orderFormStatusRef={orderFormStatusRef}
                    handleSubmitMeetingService={handleSubmitMeetingService}
                    outerFormik={formikRef}
                />
            </div>
        </Formik>
    )
}
